/* 
    Main page for the utility table view for comparing utility infrastructure options.
*/

import React from 'react';
import UtilityComparisonTable from '../../components/utility_planning/UtilityComparisonTable';

function UtilityTableView() {

    
    
    return (
        <div className="min-h-screen bg-gray-50">
                <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
                    <UtilityComparisonTable />
                </div>
        </div>
    );
}

export default UtilityTableView;
